module.exports = __webpack_public_path__ + "img/main_mobile.d637b351.png";